export const removeAccents = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const removeHtmlTags = (str: string) => {
    return str.replace(/(<([^>]+)>)/gi, '')
}

export const currentLang = "es_AR";
